export default "__VITE_ASSET__B45gGOH7VkhJBQ5AptProw__";